window.addEventListener("DOMContentLoaded", () => {
  $(".partner_slider_new").each(function(key, val) {
    var id1 = "";
    var sliderId_1 = "";
    var id1 = $(this).attr("id");
    var sliderId_1 = "#" + id1;
    if ($(sliderId_1).hasClass("slick-initialized")) {
    } else {
      $(sliderId_1).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: $("#l_" + id1),
        nextArrow: $("#r_" + id1),
        variableWidth: true,
        rtl: window.isAr,
        speed: 1e3,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              variableWidth: true,
              speed: 1e3
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              variableWidth: true,
              speed: 1e3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              variableWidth: true,
              speed: 500
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              variableWidth: true,
              speed: 500
            }
          }
        ]
      });
    }
    $("#l_" + id1).hide();
    $(sliderId_1).on("afterChange", function(event, slick, currentSlide) {
      if (currentSlide === 0) {
        $("#l_" + id1).hide();
      } else {
        $("#l_" + id1).show();
      }
    });
  });
  $(".product-list-contain").each(function(key, val) {
    var id = $(this).attr("id");
    var sliderId = "#" + id;
    $(sliderId).not(".slick-initialized").slick({
      variableWidth: true,
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      rtl: window.isAr,
      prevArrow: window.isAr ? $(this).parent().find(".next") : $(this).parent().find(".prev"),
      nextArrow: window.isAr ? $(this).parent().find(".prev") : $(this).parent().find(".next"),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });
  });
  $(document).on("click", ".freq-select-products", function() {
    if ($(".button-cart-frequent").attr("product-list") == "Cart Page") {
      var productList = "ATTACH :: Cart Page";
    } else {
      var mpn_handle = $("#mpn_handle").val();
      var productList = "Shopify Rec :: " + mpn_handle;
    }
    localStorage.setItem("product-click", productList);
  });
  $(document).on("change", ".frequent-products-checkbox", function() {
    var checkLength = $("input[name='frequent-products-pdp']:checked").length;
    $("#checked-products").text(checkLength);
    if (checkLength == 0) {
      $("#card-button").prop("disabled", true);
    } else {
      $("#card-button").prop("disabled", false);
    }
    var product_id = $(this).val();
    var prodtitle = $("#title_" + product_id).val();
    var prodMPN = $("#product_mpn_handle_" + product_id).val();
    var prodType = $(".card_product_category_" + product_id).val();
    var prodCurrency = $(".card_product_currency_" + product_id).attr("value");
    var prodPrice = $(".card_product_price_" + product_id).attr("value");
    var compareprice = $(".card_product_compare_" + product_id).attr("value");
    var prodSku = $(".card_product_sku_" + product_id).attr("value");
    prodPrice = Number(prodPrice.replace(/[^0-9.-]+/g, ""));
    prodPrice = parseFloat(prodPrice);
    var prodSku = $(".card_product_sku_" + product_id).attr("value");
    if ($(".button-cart-frequent").attr("product-list") == "Cart Page") {
      var productList = "ATTACH :: Cart Page";
    } else {
      var mpn_handle = $("#mpn_handle").val();
      var productList = "Shopify Rec :: " + mpn_handle;
    }
    localStorage.setItem("product-click", productList);
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_name: productList,
        items: [
          {
            item_id: prodSku,
            item_name: prodtitle,
            item_category: prodType,
            price: prodPrice,
            quantity: 1
          }
        ]
      }
    });
  });
  $("#card-button").on("click", function(event) {
    event.preventDefault();
    $(".button-cart-frequent").attr("aria-disabled", true);
    $(".button-cart-frequent").addClass("loading");
    $(".loading-overlay__spinner-frequent").removeClass("hidden");
    var frequentProducts = [];
    var frequentProducts_ga = [];
    var tax_total_quantity = 0;
    var quncheck = [];
    var prodTitle = [];
    var value_price = 0;
    var prodCurrency = $("#prod_currency").val();
    $.each($("input[name='frequent-products-pdp']:checked"), function() {
      var prodId = $("#product_id_" + $(this).val()).val();
      var prodQuant = 1;
      var prodMaxqut = $("#product_max_quantity_" + $(this).val()).val();
      var prodtitle = $("#title_" + $(this).val()).val();
      var prodMPN = $("#product_mpn_handle_" + $(this).val()).val();
      var prod_handle = $("#card_product_handle_" + $(this).val()).val();
      if (prodMaxqut != "") {
        var maxQuant = checkMaxquantity(prodId);
        if (maxQuant != "") {
          var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
        } else {
          var max_total_quantity = parseInt(prodQuant);
        }
        if (max_total_quantity > prodMaxqut) {
          quncheck.push(1);
          prodTitle.push(prodtitle);
        }
      }
      var taxtags_fb = $("#tags_" + $(this).val()).val();
      var addtaxfree = taxtags_fb.indexOf("taxfree") != -1;
      if (addtaxfree == true) {
        tax_total_quantity++;
      }
      item = {};
      item["quantity"] = "quantity:1";
      item["id"] = $(this).val();
      item["properties"] = {
        uuid: prod_handle,
        _date: window._date
      };
      frequentProducts.push(item);
      var prodType = $(".card_product_category_" + $(this).val()).val();
      var prodPrice = $(".card_product_price_" + $(this).val()).attr("value");
      var prodSku = $(".card_product_sku_" + $(this).val()).attr("value");
      var compareprice = $(".card_product_compare_" + $(this).val()).attr("value");
      var productList = $(".button-cart-frequent").attr("product-list");
      var mpn_handle = $("#mpn_handle").val();
      var shopify_rec = "Shopify Rec :: " + mpn_handle;
      prodPrice = Number(prodPrice.replace(/[^0-9.-]+/g, ""));
      value_price += parseFloat(prodPrice);
      value_price = parseFloat(value_price);
      var productPrice1 = parseFloat(prodPrice);
      item_ga = {};
      item_ga["item_id"] = prodSku;
      item_ga["item_name"] = prodtitle;
      item_ga["item_category"] = prodType;
      item_ga["item_list_name"] = shopify_rec;
      item_ga["price"] = parseFloat(productPrice1);
      item_ga["quantity"] = 1;
      frequentProducts_ga.push(item_ga);
    });
    if (jQuery.inArray(1, quncheck) !== -1) {
      var prod_title = prodTitle.join();
      alert(quantity_limit_error_message + " " + prod_title);
      $(".button-cart-frequent").attr("aria-disabled", false);
      $(".button-cart-frequent").removeClass("loading");
      $(".loading-overlay__spinner-frequent").addClass("hidden");
      return false;
    }
    if (vat_free_day == true) {
      if (getCookie("total_quantity") == "") {
        var tax_total_quantity = parseInt(tax_total_quantity);
      } else {
        var tax_total_quantity = parseInt(tax_total_quantity) + parseInt(getCookie("total_quantity"));
      }
      if (tax_total_quantity > vat_free_quantity) {
        alert(vat_free_message);
        $(".button-cart-frequent").attr("aria-disabled", false);
        $(".button-cart-frequent").removeClass("loading");
        $(".loading-overlay__spinner-frequent").addClass("hidden");
        return false;
      }
    }
    fetch("/cart/add.js", {
      method: "post",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({
        items: frequentProducts
      })
    }).then((response) => {
      response.json().then((d) => {
        var mpn_handle = $("#mpn_handle").val();
        var shopify_rec = "Shopify Rec :: " + mpn_handle;
        var exphone_fa = [];
        if (JSON.parse(localStorage.getItem("cart")) != null) {
          exphone_fa = JSON.parse(localStorage.getItem("cart"));
        }
        for (var i = 0; i < d.items.length; i++) {
          item_cart_fa = {};
          item_cart_fa["cart_item_id"] = d.items[i].key;
          item_cart_fa["cart_item_list_name"] = shopify_rec;
          item_cart_fa["cart_item_mpn"] = d.items[i].sku;
          exphone_fa.push(item_cart_fa);
        }
        console.log("1");
        console.log(exphone_fa);
        localStorage.setItem("cart", JSON.stringify(exphone_fa));
      });
      $.get("/cart?view=minicart", function(itemData) {
        var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
        if ($(".cart-count-bubble").length > 0) {
          $(".cart-count-bubble span").text(item_count);
        } else {
          $("#cart-icon-bubble").append('<div class="cart-count-bubble"><span></span></div>');
          $(".cart-count-bubble span").text(item_count);
        }
        $("#cart-notification").text("");
        var textreplace = "<div id='min-cart-replace'></div>";
        $("#cart-notification").append(textreplace);
        $("#cart-notification").replaceWith(itemData);
        $("#cart-notification").addClass("minicart-active");
      });
      dataLayer.push({
        ecommerce: null
      });
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          value: value_price,
          currency: prodCurrency,
          items: frequentProducts_ga
        }
      });
      $(".button-cart-frequent").attr("aria-disabled", false);
      $(".button-cart-frequent").removeClass("loading");
      $(".loading-overlay__spinner-frequent").addClass("hidden");
      if (window.location.href.indexOf("/cart") > -1) {
        location.reload();
      }
    }).catch((error) => {
      console.error("Error:", error);
      return false;
    });
    return false;
  });
  $(".slider-form").click(function(evt) {
    evt.preventDefault();
    var mpn_handle = $("#mpn_handle").val();
    var pageName = window.location.href;
    var prodId = $(this).attr("data-productid");
    var prodQuant = 1;
    var prodMaxqut = $(this).attr("data-productmaxquantity");
    var cartpage = $(this).attr("data-cartpage");
    if (cartpage == "Cart Page") {
      var attach = "ATTACH :: Cart Page";
    } else {
      var attach = "ATTACH :: ";
    }
    if (prodMaxqut != "") {
      var maxQuant = checkMaxquantity(prodId);
      if (maxQuant != "") {
        var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
      } else {
        var max_total_quantity = parseInt(prodQuant);
      }
      if (max_total_quantity > prodMaxqut) {
        alert(quantity_limit_error_message);
        return false;
      }
    }
    var slider_variantid = $(this).attr("data-variantid");
    var slider_tag = $(this).attr("data-tag");
    var collection_name = $(this).attr("data-collection");
    var main_product_sku = $(this).attr("data-productsku");
    if (pageName.includes("products")) {
      var mpn_handle = $("#mpn_handle").val();
      var productList = mpn_handle;
    } else {
      var productList = formatString($(this).attr("data-productlist"));
    }
    var productCategory = $(this).attr("data-producttype");
    var productPrice = $(this).attr("data-productprice");
    var productcomPrice = $(this).attr("data-productcompprice");
    var productCurrency = $(this).attr("data-productcurrency");
    var productTitle = $(this).attr("data-producttitle");
    var productMPN = $(this).attr("data-productMPN");
    var productHandle = $(this).attr("data-producthandle");
    if (vat_free_day == true) {
      var addtaxfree = slider_tag.indexOf("taxfree") != -1;
      if (addtaxfree == true) {
        if (getCookie("total_quantity") >= vat_free_quantity) {
          alert(vat_free_message);
          return false;
        }
      }
    }
    $("#slider-form-" + slider_variantid).attr("aria-disabled", true);
    $("#slider-form-" + slider_variantid).addClass("loading");
    $(".loading-overlay__spinner-frequent").removeClass("hidden");
    fetch("/cart/add.js", {
      method: "post",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: slider_variantid,
            quantity: 1,
            properties: {
              uuid: productHandle,
              _date: window._date
            }
          }
        ]
      })
    }).then((response) => {
      response.json().then((d) => {
        cartCookie(productMPN, d.items[0].key, prod_list);
      });
      if (cartpage == "Cart Page") {
        var prod_list = attach;
      } else {
        var prod_list = attach + productList;
      }
      triggerGAAddToCart(
        productcomPrice,
        main_product_sku,
        productTitle,
        productCategory,
        prod_list,
        productCurrency,
        productPrice,
        prodQuant,
        main_product_sku,
        slider_variantid
      );
      if (cartpage == "Cart Page") {
        location.reload();
        return false;
      }
      $.get("/cart?view=minicart", function(itemData) {
        var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
        if ($(".cart-count-bubble").length > 0) {
          $(".cart-count-bubble span").text(item_count);
        } else {
          $("#cart-icon-bubble").append('<div class="cart-count-bubble"><span></span></div>');
          $(".cart-count-bubble span").text(item_count);
        }
        $("#cart-notification").text("");
        var textreplace = "<div id='min-cart-replace'></div>";
        $("#cart-notification").append(textreplace);
        $("#cart-notification").replaceWith(itemData);
        $("#cart-notification").addClass("minicart-active");
      });
      $("#slider-form-" + slider_variantid).attr("aria-disabled", false);
      $("#slider-form-" + slider_variantid).removeClass("loading");
      $(".loading-overlay__spinner-frequent").addClass("hidden");
    }).catch((error) => {
      console.error("Error:", error);
      return false;
    });
    return false;
  });
  $(document).on("click", ".add-cart-apple-care", function(e) {
    e.preventDefault();
    $(this).prop("disabled", true);
    var add_button = $(this);
    var product_id = add_button.data("variantid");
    var main_product_index = add_button.data("forproduct");
    var wp_idx = add_button.data("forwproduct");
    var wp_key = add_button.data("forwkey");
    var main_product_parent = $("#CartItem-" + main_product_index);
    var has_applcr_sku = main_product_parent.data("applecare_sku").trim();
    var has_applcr_handle = main_product_parent.data("applecare_handle");
    var has_sw_sku = main_product_parent.data("secwarranty_sku").trim();
    var has_sw_handle = main_product_parent.data("secwarranty_handle");
    var main_product_quantity = main_product_parent.find(".quantity__input").val();
    var main_product_sku = add_button.data("skuparent");
    var main_product_handle = add_button.data("handleparent");
    var main_product_key = add_button.data("keyparent");
    var aplCr_sku = add_button.data("skuaplcr");
    var applecarempn = add_button.data("mpnaplcr");
    var aplCr_handle = add_button.data("handleaplcr");
    var main_mpn_value = add_button.data("mpnparent");
    var additional_flag = add_button.data("reference");
    var main_product_tags = main_product_parent.find(".cart_tax_tags").val();
    if (additional_flag == "secwr") {
      if (has_applcr_sku) {
        var uid = main_product_handle + "-" + has_applcr_handle + "-" + aplCr_handle;
        var data = '{ "line":"' + main_product_index + '", "quantity": ' + main_product_quantity + ', "properties":{ "uuid": "' + uid + '", "applecare_sku": "' + has_applcr_sku + '", "applecare_handle": "' + has_applcr_handle + '", "secWarranty_sku": "' + aplCr_sku + '", "secWarranty_handle": "' + aplCr_handle + '", "_date":"' + window._date + '" } }';
      } else {
        var uid = main_product_handle + "-" + aplCr_handle;
        var data = '{ "line":"' + main_product_index + '", "quantity": ' + main_product_quantity + ', "properties":{ "uuid": "' + uid + '", "secWarranty_sku": "' + aplCr_sku + '", "secWarranty_handle": "' + aplCr_handle + '", "_date":"' + window._date + '" } }';
      }
    } else {
      if (has_sw_sku) {
        var uid = main_product_handle + "-" + aplCr_handle + "-" + has_sw_handle;
        var data = '{ "line":"' + main_product_index + '", "quantity": ' + main_product_quantity + ', "properties":{ "uuid": "' + uid + '", "secWarranty_sku": "' + has_sw_sku + '", "secWarranty_handle": "' + has_sw_handle + '", "applecare_sku": "' + aplCr_sku + '", "applecare_handle": "' + aplCr_handle + '", "_date":"' + window._date + '" } }';
      } else {
        var uid = main_product_handle + "-" + aplCr_handle;
        var data = '{ "line":"' + main_product_index + '", "quantity": ' + main_product_quantity + ', "properties":{ "uuid": "' + uid + '", "applecare_sku": "' + aplCr_sku + '", "applecare_handle": "' + aplCr_handle + '", "_date":"' + window._date + '" } }';
      }
    }
    if (has_applcr_sku) {
      var data2 = '{ "id":"' + wp_key + '", "quantity": ' + main_product_quantity + ', "properties": { "aplcr_main_product_sku": "' + main_product_sku + '", "aplcr_main_product_handle": "' + main_product_handle + '", "uuid": "' + uid + '", "_date":"' + window._date + '" } }';
    } else {
      var data2 = '{ "id":"' + wp_key + '", "quantity": ' + main_product_quantity + ', "properties": { "sw_main_product_sku": "' + main_product_sku + '", "sw_main_product_handle": "' + main_product_handle + '", "uuid": "' + uid + '", "_date":"' + window._date + '" } }';
    }
    if (!has_applcr_sku && !has_sw_sku) {
      var wp_idx = 0;
    }
    $.ajax({
      url: "/cart/change.js",
      type: "POST",
      data,
      contentType: "application/json",
      dataType: "json",
      success: function(data3) {
        if (wp_idx >= 1) {
          $.ajax({
            url: "/cart/change.js",
            type: "POST",
            data: data2,
            contentType: "application/json",
            dataType: "json",
            success: function(data4) {
              if (additional_flag == "secwr") {
                if (has_applcr_sku) {
                  fetch("/cart/add.js", {
                    method: "post",
                    headers: {
                      "content-type": "application/json"
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: product_id,
                          quantity: main_product_quantity,
                          properties: {
                            sw_main_product_sku: main_product_sku,
                            sw_main_product_handle: main_product_handle,
                            uuid: uid,
                            _date: window._date
                          }
                        }
                      ]
                    })
                  }).then((response) => {
                    console.log(response.json());
                    location.reload();
                  }).catch((error) => {
                    console.error("Error:", error);
                    return false;
                  });
                } else {
                  fetch("/cart/add.js", {
                    method: "post",
                    headers: {
                      "content-type": "application/json"
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: product_id,
                          quantity: main_product_quantity,
                          properties: {
                            sw_main_product_sku: main_product_sku,
                            sw_main_product_handle: main_product_handle,
                            uuid: uid,
                            _date: window._date
                          }
                        }
                      ]
                    })
                  }).then((response) => {
                    console.log(response.json());
                    location.reload();
                  }).catch((error) => {
                    console.error("Error:", error);
                    return false;
                  });
                }
              } else {
                if (has_sw_sku) {
                  fetch("/cart/add.js", {
                    method: "post",
                    headers: {
                      "content-type": "application/json"
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: product_id,
                          quantity: main_product_quantity,
                          properties: {
                            aplcr_main_product_sku: main_product_sku,
                            aplcr_main_product_handle: main_product_handle,
                            uuid: uid,
                            _date: window._date
                          }
                        }
                      ]
                    })
                  }).then((response) => {
                    console.log(response.json());
                    location.reload();
                  }).catch((error) => {
                    console.error("Error:", error);
                    return false;
                  });
                } else {
                  fetch("/cart/add.js", {
                    method: "post",
                    headers: {
                      "content-type": "application/json"
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: product_id,
                          quantity: main_product_quantity,
                          properties: {
                            aplcr_main_product_sku: main_product_sku,
                            aplcr_main_product_handle: main_product_handle,
                            uuid: uid,
                            _date: window._date
                          }
                        }
                      ]
                    })
                  }).then((response) => {
                    console.log(response.json());
                    location.reload();
                  }).catch((error) => {
                    console.error("Error:", error);
                    return false;
                  });
                }
              }
            }
          });
        } else {
          if (additional_flag == "secwr") {
            if (has_applcr_sku) {
              fetch("/cart/add.js", {
                method: "post",
                headers: {
                  "content-type": "application/json"
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: product_id,
                      quantity: main_product_quantity,
                      properties: {
                        sw_main_product_sku: main_product_sku,
                        sw_main_product_handle: main_product_handle,
                        uuid: uid,
                        _date: window._date
                      }
                    }
                  ]
                })
              }).then((response) => {
                console.log(response.json());
                location.reload();
              }).catch((error) => {
                console.error("Error:", error);
                return false;
              });
            } else {
              fetch("/cart/add.js", {
                method: "post",
                headers: {
                  "content-type": "application/json"
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: product_id,
                      quantity: main_product_quantity,
                      properties: {
                        sw_main_product_sku: main_product_sku,
                        sw_main_product_handle: main_product_handle,
                        uuid: uid,
                        _date: window._date
                      }
                    }
                  ]
                })
              }).then((response) => {
                console.log(response.json());
                location.reload();
              }).catch((error) => {
                console.error("Error:", error);
                return false;
              });
            }
          } else {
            if (has_sw_sku) {
              fetch("/cart/add.js", {
                method: "post",
                headers: {
                  "content-type": "application/json"
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: product_id,
                      quantity: main_product_quantity,
                      properties: {
                        aplcr_main_product_sku: main_product_sku,
                        aplcr_main_product_handle: main_product_handle,
                        uuid: uid,
                        _date: window._date
                      }
                    }
                  ]
                })
              }).then((response) => {
                console.log(response.json());
                location.reload();
              }).catch((error) => {
                console.error("Error:", error);
                return false;
              });
            } else {
              fetch("/cart/add.js", {
                method: "post",
                headers: {
                  "content-type": "application/json"
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: product_id,
                      quantity: main_product_quantity,
                      properties: {
                        aplcr_main_product_sku: main_product_sku,
                        aplcr_main_product_handle: main_product_handle,
                        uuid: uid,
                        _date: window._date
                      }
                    }
                  ]
                })
              }).then((response) => {
                console.log(response.json());
                location.reload();
              }).catch((error) => {
                console.error("Error:", error);
                return false;
              });
            }
          }
        }
      }
    });
  });
  $("#footer-atc").click(function(evt) {
    evt.preventDefault();
    var prodVariantID = $("#main-product-variant").val();
    var prodId = $("#product_id").val();
    var prodQuant = $("#prodQuantity").val();
    var prodMaxqut = $("#product_max_quantity").val();
    var total_qty = $("#total_qty_" + prodVariantID).val();
    var maxQuant = checkMaxquantity(prodId);
    if (maxQuant != "") {
      var max_total_quantity = parseInt(prodQuant) + parseInt(maxQuant);
    } else {
      var max_total_quantity = parseInt(prodQuant);
    }
    if (max_total_quantity > prodMaxqut) {
      alert("Sorry! you reached maximum limit for this product!");
      return false;
    }
    if (vat_free_day == true) {
      var taxtags = $("#tax_tags").val();
      var prodQuant = $("#prodQuantity").val();
      var addtaxfree = taxtags.indexOf("taxfree") != -1;
      if (getCookie("total_quantity") == "") {
        var tax_total_quantity = parseInt(prodQuant);
      } else {
        var tax_total_quantity = parseInt(prodQuant) + parseInt(getCookie("total_quantity"));
      }
      if (addtaxfree == true) {
        if (tax_total_quantity > vat_free_quantity) {
          alert(vat_free_message);
          return false;
        } else {
          addToCart("cart");
        }
      } else {
        addToCart("cart");
      }
    } else {
      addToCart("cart");
    }
    return false;
  });
  $("#footer-buynow").click(function(evt) {
    evt.preventDefault();
    var prodVariantID = $("#main-product-variant").val();
    var mpn_handle = $("#mpn_handle_" + prodVariantID).val();
    if (vat_free_day == true) {
      var taxtags = $("#tax_tags").val();
      var prodQuant = $("#prodQuantity").val();
      var addtaxfree = taxtags.indexOf("taxfree") != -1;
      if (getCookie("total_quantity") == "") {
        var tax_total_quantity = parseInt(prodQuant);
      } else {
        var tax_total_quantity = parseInt(prodQuant) + parseInt(getCookie("total_quantity"));
      }
      if (addtaxfree == true) {
        if (tax_total_quantity > vat_free_quantity) {
          alert(vat_free_message);
          return false;
        }
      }
    }
    if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
      var proliststring = $(".pdp_product_list").attr("value");
    } else {
      var proliststring = formatString($(".pdp_product_list").attr("value"));
    }
    var productList = proliststring;
    addToCart("buy");
  });
  $("#footer-buynow_normal").on("click", function(evt) {
    evt.preventDefault();
    var prodVariantID = $("#main-product-variant").val();
    var mpn_handle = $("#mpn_handle_" + prodVariantID).val();
    if (vat_free_day == true) {
      var taxtags = $("#tax_tags").val();
      var prodQuant = $("#prodQuantity").val();
      var addtaxfree = taxtags.indexOf("taxfree") != -1;
      if (getCookie("total_quantity") == "") {
        var tax_total_quantity = parseInt(prodQuant);
      } else {
        var tax_total_quantity = parseInt(prodQuant) + parseInt(getCookie("total_quantity"));
      }
      if (addtaxfree == true) {
        if (tax_total_quantity > vat_free_quantity) {
          alert(vat_free_message);
          return false;
        }
      }
    }
    if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
      var proliststring = $(".pdp_product_list").attr("value");
    } else {
      var proliststring = formatString($(".pdp_product_list").attr("value"));
    }
    var productList = proliststring;
    addToCart("buy");
  });
  function addToCart(check_buy) {
    var taxtags = $("#tax_tags").val();
    var btn = $(this).find(".BUY_NOW_CLICKED");
    var buy_now_checker = btn.data("submit");
    var isChecked = $("#add-apple-care").is(":checked");
    var isChecked2 = $("#add-secWarranty").is(":checked");
    var prodVariantID = $("#main-product-variant").val();
    var mpn_handle = $("#mpn_handle_" + prodVariantID).val();
    var productcomPrice = $("#compr_price_" + prodVariantID).val();
    var uuid = Math.random().toString(36).slice(2);
    if (isChecked == true || isChecked2 == true) {
      if (isChecked == true && isChecked2 == true) {
        var prodMaxqut = $("#product_max_quantity").val();
        var applecareID = $("#apple-care-varid").val();
        var applecaresku = $("#applecare-product-sku").val();
        var applecarempn = $("#applecare-product-mpn").val();
        var applecarehandle = $("#applecare-product-handle").val();
        var secWarrantyID = $("#secWarranty-varid").val();
        var secWarrantysku = $("#secWarranty-product-sku").val();
        var secWarrantympn = $("#secWarranty-product-mpn").val();
        var secWarrantyhandle = $("#secWarranty-product-handle").val();
        var main_product_sku = $("#main-pro-sku").val();
        var main_product_handle = $("#main-pro-handle").val();
        var prodVariantID = $("#main-product-variant").val();
        var prodQuant = $("#prodQuantity").val();
        var taxtags = $("#tax_tags").val();
        var uid = main_product_handle + "-" + applecarehandle + "-" + secWarrantyhandle;
        fetch("/cart/add.js", {
          method: "post",
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: secWarrantyID,
                quantity: prodQuant,
                properties: {
                  sw_main_product_sku: main_product_sku,
                  sw_main_product_handle: main_product_handle,
                  uuid: uid,
                  _date: window._date
                }
              },
              {
                id: applecareID,
                quantity: prodQuant,
                properties: {
                  aplcr_main_product_sku: main_product_sku,
                  aplcr_main_product_handle: main_product_handle,
                  uuid: uid,
                  _date: window._date
                }
              },
              {
                id: prodVariantID,
                quantity: prodQuant,
                properties: {
                  applecare_sku: applecaresku,
                  applecare_handle: applecarehandle,
                  secWarranty_sku: secWarrantysku,
                  secWarranty_handle: secWarrantyhandle,
                  uuid: uid,
                  _date: window._date
                }
              }
            ]
          })
        }).then((response) => {
          response.json().then((d) => {
            if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
              var proliststring = $(".pdp_product_list").attr("value");
            } else {
              var proliststring = formatString($(".pdp_product_list").attr("value"));
            }
            var productList = proliststring;
            cartCookie(mpn_handle, d.items[2].key, productList);
            triggerGAAddToCart(
              productcomPrice,
              mpn_handle,
              productTitle,
              productCategory,
              productList,
              productCurrency,
              productPrice,
              prodQuant2,
              main_product_sku2,
              prodVariantID
            );
          });
          if (check_buy == "buy") {
            $.get("/cart?view=minicart", function(itemData) {
              var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
              if ($(".cart-count-bubble").length > 0) {
                $(".cart-count-bubble span").text(item_count);
              } else {
                $("#cart-icon-bubble").append(
                  '<div class="cart-count-bubble"><span></span></div>'
                );
                $(".cart-count-bubble span").text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              $("#cart-notification").addClass("minicart-active");
              $("#cart-notification").css("visibility", "hidden");
              $(".cart-count-bubble").css("visibility", "hidden");
              window.location.href = "/checkout";
            });
          } else {
            $.get("/cart?view=minicart", function(itemData) {
              var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
              if ($(".cart-count-bubble").length > 0) {
                $(".cart-count-bubble span").text(item_count);
              } else {
                $("#cart-icon-bubble").append(
                  '<div class="cart-count-bubble"><span></span></div>'
                );
                $(".cart-count-bubble span").text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              $("#cart-notification").addClass("minicart-active");
            });
            var main_product_sku2 = $("#main-pro-sku").val();
            var productCategory = $(".pdp_product_category").attr("value");
            var productCurrency = $(".pdp_product_currency").attr("value");
            var productPrice1 = $(".pdp_product_price").attr("value");
            var productPrice = $("#prod_price_" + prodVariantID).val();
            var productTitle = $(".pdp_product_title").attr("value");
            var prodQuant2 = $("#prodQuantity").val();
          }
        }).catch((error) => {
          console.error("Error:", error);
          return false;
        }).finally(() => {
        });
      } else if (isChecked == false && isChecked2 == true) {
        var secWarrantyID = $("#secWarranty-varid").val();
        var secWarrantysku = $("#secWarranty-product-sku").val();
        var secWarrantympn = $("#secWarranty-product-mpn").val();
        var secWarrantyhandle = $("#secWarranty-product-handle").val();
        var main_product_sku = $("#main-pro-sku").val();
        var main_product_handle = $("#main-pro-handle").val();
        var prodVariantID = $("#main-product-variant").val();
        var prodQuant = $("#prodQuantity").val();
        var taxtags = $("#tax_tags").val();
        var uid = main_product_handle + "-" + secWarrantyhandle;
        fetch("/cart/add.js", {
          method: "post",
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: secWarrantyID,
                quantity: prodQuant,
                properties: {
                  sw_main_product_sku: main_product_sku,
                  sw_main_product_handle: main_product_handle,
                  uuid: uid,
                  _date: window._date
                }
              },
              {
                id: prodVariantID,
                quantity: prodQuant,
                properties: {
                  secWarranty_sku: secWarrantysku,
                  secWarranty_handle: secWarrantyhandle,
                  uuid: uid,
                  _date: window._date
                }
              }
            ]
          })
        }).then((response) => {
          response.json().then((d) => {
            if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
              var proliststring = $(".pdp_product_list").attr("value");
            } else {
              var proliststring = formatString($(".pdp_product_list").attr("value"));
            }
            var productList = proliststring;
            cartCookie(mpn_handle, d.items[1].key, productList);
            triggerGAAddToCart(
              productcomPrice,
              mpn_handle,
              productTitle,
              productCategory,
              productList,
              productCurrency,
              productPrice,
              prodQuant2,
              main_product_sku2,
              prodVariantID
            );
          });
          if (check_buy == "buy") {
            $.get("/cart?view=minicart", function(itemData) {
              var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
              if ($(".cart-count-bubble").length > 0) {
                $(".cart-count-bubble span").text(item_count);
              } else {
                $("#cart-icon-bubble").append(
                  '<div class="cart-count-bubble"><span></span></div>'
                );
                $(".cart-count-bubble span").text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              $("#cart-notification").addClass("minicart-active");
              $("#cart-notification").css("visibility", "hidden");
              $(".cart-count-bubble").css("visibility", "hidden");
              window.location.href = "/checkout";
            });
          } else {
            $.get("/cart?view=minicart", function(itemData) {
              var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
              if ($(".cart-count-bubble").length > 0) {
                $(".cart-count-bubble span").text(item_count);
              } else {
                $("#cart-icon-bubble").append(
                  '<div class="cart-count-bubble"><span></span></div>'
                );
                $(".cart-count-bubble span").text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              $("#cart-notification").addClass("minicart-active");
            });
            var main_product_sku2 = $("#main-pro-sku").val();
            var productCategory = $(".pdp_product_category").attr("value");
            var productCurrency = $(".pdp_product_currency").attr("value");
            var productPrice1 = $(".pdp_product_price").attr("value");
            var productPrice = $("#prod_price_" + prodVariantID).val();
            var productTitle = $(".pdp_product_title").attr("value");
            var prodQuant2 = $("#prodQuantity").val();
          }
        }).catch((error) => {
          console.error("Error:", error);
          return false;
        }).finally(() => {
        });
      } else if (isChecked == true && isChecked2 == false) {
        var prodMaxqut = $("#product_max_quantity").val();
        var applecareID = $("#apple-care-varid").val();
        var applecaresku = $("#applecare-product-sku").val();
        var applecarempn = $("#applecare-product-mpn").val();
        var applecarehandle = $("#applecare-product-handle").val();
        var main_product_sku = $("#main-pro-sku").val();
        var main_product_handle = $("#main-pro-handle").val();
        var prodVariantID = $("#main-product-variant").val();
        var prodQuant = $("#prodQuantity").val();
        var taxtags = $("#tax_tags").val();
        var uid = main_product_handle + "-" + applecarehandle;
        fetch("/cart/add.js", {
          method: "post",
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: applecareID,
                quantity: prodQuant,
                properties: {
                  aplcr_main_product_sku: main_product_sku,
                  aplcr_main_product_handle: main_product_handle,
                  uuid: uid,
                  _date: window._date
                }
              },
              {
                id: prodVariantID,
                quantity: prodQuant,
                properties: {
                  applecare_sku: applecaresku,
                  applecare_handle: applecarehandle,
                  uuid: uid,
                  _date: window._date
                }
              }
            ]
          })
        }).then((response) => {
          response.json().then((d) => {
            if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
              var proliststring = $(".pdp_product_list").attr("value");
            } else {
              var proliststring = formatString($(".pdp_product_list").attr("value"));
            }
            var productList = proliststring;
            cartCookie(mpn_handle, d.items[1].key, productList);
            triggerGAAddToCart(
              productcomPrice,
              mpn_handle,
              productTitle,
              productCategory,
              productList,
              productCurrency,
              productPrice,
              prodQuant2,
              main_product_sku2,
              prodVariantID
            );
          });
          if (check_buy == "buy") {
            $.get("/cart?view=minicart", function(itemData) {
              var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
              if ($(".cart-count-bubble").length > 0) {
                $(".cart-count-bubble span").text(item_count);
              } else {
                $("#cart-icon-bubble").append(
                  '<div class="cart-count-bubble"><span></span></div>'
                );
                $(".cart-count-bubble span").text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              $("#cart-notification").addClass("minicart-active");
              $("#cart-notification").css("visibility", "hidden");
              $(".cart-count-bubble").css("visibility", "hidden");
              window.location.href = "/checkout";
            });
          } else {
            $.get("/cart?view=minicart", function(itemData) {
              var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
              if ($(".cart-count-bubble").length > 0) {
                $(".cart-count-bubble span").text(item_count);
              } else {
                $("#cart-icon-bubble").append(
                  '<div class="cart-count-bubble"><span></span></div>'
                );
                $(".cart-count-bubble span").text(item_count);
              }
              $("#cart-notification").text("");
              var textreplace = "<div id='min-cart-replace'></div>";
              $("#cart-notification").append(textreplace);
              $("#cart-notification").replaceWith(itemData);
              $("#cart-notification").addClass("minicart-active");
            });
            var main_product_sku2 = $("#main-pro-sku").val();
            var productCategory = $(".pdp_product_category").attr("value");
            var productCurrency = $(".pdp_product_currency").attr("value");
            var productPrice1 = $(".pdp_product_price").attr("value");
            var productPrice = $("#prod_price_" + prodVariantID).val();
            var productTitle = $(".pdp_product_title").attr("value");
            var prodQuant2 = $("#prodQuantity").val();
          }
        }).catch((error) => {
          console.error("Error:", error);
          return false;
        }).finally(() => {
        });
      }
    } else {
      var main_product_handle = $("#main-pro-handle").val();
      var main_product_sku = $("#main-pro-sku").val();
      var prodQuant = $("#prodQuantity").val();
      var prodVariantID = $("#main-product-variant").val();
      fetch("/cart/add.js", {
        method: "post",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: prodVariantID,
              quantity: prodQuant,
              properties: {
                uuid: main_product_handle,
                _date: window._date
              }
            }
          ]
        })
      }).then((response) => {
        response.json().then((d) => {
          if ($(".pdp_product_list").attr("value").indexOf("PLP ::") >= 0) {
            var proliststring = $(".pdp_product_list").attr("value");
          } else {
            var proliststring = formatString($(".pdp_product_list").attr("value"));
          }
          var productList = proliststring;
          cartCookie(mpn_handle, d.items[0].key, productList);
          triggerGAAddToCart(
            productcomPrice,
            mpn_handle,
            productTitle,
            productCategory,
            productList,
            productCurrency,
            productPrice,
            prodQuant2,
            main_product_sku2,
            prodVariantID
          );
        });
        if (check_buy == "buy") {
          $.get("/cart?view=minicart", function(itemData) {
            var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
            if ($(".cart-count-bubble").length > 0) {
              $(".cart-count-bubble span").text(item_count);
            } else {
              $("#cart-icon-bubble").append('<div class="cart-count-bubble"><span></span></div>');
              $(".cart-count-bubble span").text(item_count);
            }
            $("#cart-notification").text("");
            var textreplace = "<div id='min-cart-replace'></div>";
            $("#cart-notification").append(textreplace);
            $("#cart-notification").replaceWith(itemData);
            $("#cart-notification").addClass("minicart-active");
            $("#cart-notification").css("visibility", "hidden");
            $(".cart-count-bubble").css("visibility", "hidden");
            window.location.href = "/checkout";
          });
        } else {
          $.get("/cart?view=minicart", function(itemData) {
            var item_count = jQuery(itemData).find("#cart-notification-button .count").text();
            if ($(".cart-count-bubble").length > 0) {
              $(".cart-count-bubble span").text(item_count);
            } else {
              $("#cart-icon-bubble").append('<div class="cart-count-bubble"><span></span></div>');
              $(".cart-count-bubble span").text(item_count);
            }
            $("#cart-notification").text("");
            var textreplace = "<div id='min-cart-replace'></div>";
            $("#cart-notification").append(textreplace);
            $("#cart-notification").replaceWith(itemData);
            $("#cart-notification").addClass("minicart-active");
          });
          var main_product_sku2 = $("#main-pro-sku").val();
          var productCategory = $(".pdp_product_category").attr("value");
          var productCurrency = $(".pdp_product_currency").attr("value");
          var productPrice1 = $(".pdp_product_price").attr("value");
          var productPrice = $("#prod_price_" + prodVariantID).val();
          var productTitle = $(".pdp_product_title").attr("value");
          var prodQuant2 = $("#prodQuantity").val();
        }
      }).catch((e) => {
        console.error(e);
      }).finally(() => {
      });
    }
  }
  function cartCookie(mpn_handle, prodVariantID, productList) {
    var prevPage = document.referrer;
    var search_value = "";
    var first_search = "";
    if (prevPage.includes("search")) {
      first_search = localStorage.getItem("search_value");
      search_value = localStorage.getItem("search_value_term");
      if (first_search == null) {
        localStorage.setItem("search_value", search_value);
        var first_search_str = localStorage.getItem("search_value");
        first_search = formatString(first_search_str);
      }
    }
    var exphone = [];
    var item_cart = {};
    item_cart["cart_item_id"] = prodVariantID;
    item_cart["cart_item_list_name"] = productList;
    item_cart["cart_item_mpn"] = mpn_handle;
    item_cart["cart_search_term"] = first_search;
    if (JSON.parse(localStorage.getItem("cart")) != null) {
      exphone = JSON.parse(localStorage.getItem("cart"));
    }
    exphone.push(item_cart);
    localStorage.setItem("cart", JSON.stringify(exphone));
    console.log(JSON.parse(localStorage.getItem("cart")));
  }
  function triggerGAAddToCart(productcomPrice, mpn, productTitle, productCategory, productList, productCurrency, productPrice, prodQuant, main_product_sku, prod_variantID) {
    var prevPage = document.referrer;
    var search_value = "";
    if (prevPage.includes("search")) {
      var first_search = localStorage.getItem("search_value");
      search_value = localStorage.getItem("search_value_term");
      if (first_search == null) {
        localStorage.setItem("search_value", search_value);
        var first_search_str = localStorage.getItem("search_value");
        first_search = formatString(first_search_str);
      }
    }
    dataLayer.push({
      ecommerce: null
    });
    productPrice = Number(productPrice.replace(/[^0-9.-]+/g, ""));
    var value_price = productPrice * parseInt(prodQuant);
    var discount = 0;
    var value_price1 = parseFloat(value_price);
    var productPrice1 = parseFloat(productPrice);
    dataLayer.push({
      event: "add_to_cart",
      search_term: search_value,
      currency: productCurrency,
      value: value_price1,
      ecommerce: {
        items: [
          {
            item_id: mpn,
            item_name: productTitle,
            item_category: productCategory,
            item_list_name: productList,
            price: productPrice1,
            quantity: parseInt(prodQuant)
          }
        ]
      }
    });
  }
  function formatString(str) {
    return str.replace(/(\B)[^ ]*/g, (match) => match.toLowerCase()).replace(/^[^ ]/g, (match) => match.toUpperCase());
  }
  function miniCart() {
    $.get("/cart?view=minicart", function(itemData) {
      $("cart-notification").replaceWith(itemData);
      $("#cart-notification").addClass("minicart-active");
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/cart.js",
        success: function(cart) {
          let total = cart.item_count;
          $(".cart-count-bubble").text(total);
        }
      });
    });
  }
});
function checkMaxquantity(product_id) {
  var total_max_quantity = 0;
  var product_id = product_id;
  $.ajax({
    type: "GET",
    dataType: "json",
    async: false,
    url: "/cart.js",
    success: function(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        var product_cartid = cart.items[i].product_id;
        if (product_cartid == product_id) {
          total_max_quantity += cart.items[i].quantity;
        }
      }
    }
  });
  return total_max_quantity;
}
function checkQuantity() {
  var total_quantity = 0;
  var cart_key = [];
  $.ajax({
    type: "GET",
    dataType: "json",
    url: "/cart.js",
    success: function(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        var tags = cart.items[i].properties.__taxtags;
        if (tags != void 0) {
          var list = tags.split(",");
          var found = false;
          for (var j = 0; j < list.length; ++j) {
            cart_key.push(cart.items[i].properties.__taxtags);
            if (list[j] == "taxfree") {
              total_quantity += cart.items[i].quantity;
            }
          }
        }
      }
      setCookie("total_quantity", total_quantity, 7);
      setCookie("cart_key", cart_key, 7);
    }
  });
}
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = /* @__PURE__ */ new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ")
      c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0)
      return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
